Devuelve agentes de IA enrutable disponibles para la organización autenticada.

Use este endpoint antes de `POST /public/v1/calls/` para descubrir qué valores de `ai_agent_id` se pueden usar y qué variables dinámicas exige cada agente.

<ApiCodeExamples exampleId="agentsList" />

<ApiResponseExamples exampleId="agentsList" />

## Alcance obligatorio

- `agents.read`

## Endpoints

- `GET /public/v1/agents/`: lista paginada.
- `GET /public/v1/agents/{id}/`: detalle de un agente.

El detalle usa el mismo formato de campos del item de lista.

## Query parameters

- `page` (`integer`, opcional): número de página.
- `page_size` (`integer`, opcional): cantidad de items por página. Default `25`, máximo `100`.
- `search` (`string`, opcional): busca por nombre del agente.
- `ordering` (`string`, opcional): `name` o `-name`.

## Campos de respuesta

- `id` (`uuid`): id público del agente para enviar como `ai_agent_id`.
- `name` (`string`): nombre del agente.
- `variables` (`array<string>`): claves de variables dinámicas exigidas por el agente. Toda clave listada aquí debe enviarse en `dynamic_variables` al crear la llamada.
- `transfer_target_required` (`boolean`): indica si `POST /public/v1/calls/` debe incluir `transfer_target`.
- `requires_pre_call_script` (`boolean`): indica si `POST /public/v1/calls/` debe incluir un `pre_call_script_id` válido.

La lista muestra solo agentes outbound activos que pasan la misma validación de ruteo usada por campañas y launcher. Los agentes inbound nunca son aceptados para crear llamadas por API pública.

## Errores esperados

- `401 Unauthorized`: token inválido, expirado, revocado, ausente o bloqueado por IP.
- `403 Forbidden`: la credencial no tiene `agents.read`.
- `404 Not Found`: el id del detalle no está disponible para la organización.
- `429 Too Many Requests`: rate limit de la credencial excedido.
